<template>
  <div class="fixed_page"  id="blurry">
    <div class="get-started">
      <div class="fixed_page">
          <div class="home_stats_box profile_stats_box" v-if="!isEditMode()">
            <div class="profile_row flex-row">
            <img class="avatar_profile" :src="userDetails.avatar" alt="">
            <div class="profile_edit_icon_bg"
                 @click.prevent="toEdit()"
                 style="cursor: pointer" >
              <img class="profile_edit_icon" src="/static/images/home/icon-edit.svg" />
            </div>
              <div class=" profile_user_info"> <h4>{{ userDetails.username }}</h4></div>
            <span class="name msisdn_num" v-if="showMsisdnInProfilePage">{{ userDetails.msisdn }}</span>
            </div>
            <profile-stats></profile-stats>
          </div>
        <div v-if="isEditMode()">
          <div class="profile_edit_box">
            <img  :src="userDetails.avatar" />
            <h1>{{ userDetails.username }}</h1>
          </div>
          <profile-edit></profile-edit>
        </div>
        <div class="soccer_background" v-if="!isEditMode()">
          <default-content-profile></default-content-profile>
        </div>

        </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import ProfileStats from './ProfileStats';
import ProfileEdit from './ProfileEdit';
import DefaultContentProfile from './DefaultContentProfile';

export default {
  name: 'profile',
  components: { DefaultContentProfile, ProfileEdit, ProfileStats },
  created() {
    this.setProfilePath(true);
  },
  methods: {
    toEdit() {
      this.$router.push('/home/profile/edit');
    },
    isEditMode() {
      return this.$route.path === '/home/profile/edit';
    },
    ...mapMutations('common', [
      'setProfilePath',
    ]),
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'userAvatar',
      'profilePath',
      'showMsisdnInProfilePage',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/Profile.vue